import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55775567"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-application" }
const _hoisted_2 = { class: "label-wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "上传申请书图片", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "申请书示例", -1))

import { Ref, ref } from 'vue'
import type { CommonUploaderFileListItem } from '@/types/public'
import UplaodImage from '@/components/upload/UploadImage.vue'
import JijiaApplicationExample from './jijia-application-example.vue'
import IconCircleQuerystion from '@/components/icon/IconCircleQuestion.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'jijia-upload-application',
  props: {
    fileUrl: { default: '' },
    mode: { default: 'surrender' }
  },
  emits: ['update:fileUrl'],
  setup(__props: any, { emit: emits }) {

const props = __props as { fileUrl: string, mode: string };



const applicationExampleVisible = ref(false)
const uploadFileList: Ref<CommonUploaderFileListItem[]> = ref([])

function uploadChangeHandle(files: CommonUploaderFileListItem[]) {
  uploadFileList.value = files
  emits('update:fileUrl', uploadFileList.value[0]?.response?.guid || '')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", {
          class: "check-example",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (applicationExampleVisible.value = true))
        }, [
          _hoisted_4,
          _createVNode(IconCircleQuerystion)
        ])
      ]),
      _createVNode(UplaodImage, {
        maxCount: 1,
        onChange: uploadChangeHandle
      })
    ]),
    _createVNode(JijiaApplicationExample, {
      show: applicationExampleVisible.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((applicationExampleVisible).value = $event)),
      mode: props.mode
    }, null, 8, ["show", "mode"])
  ], 64))
}
}

})